import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ContextMenuItemModel, GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../../../src/app/shared/shared.functions';

import { MovimientoService } from '../../../../../../src/app/shared/services';
import { DialogDetalleMovimientosConsolidadoCajaRequestDto, GridPageSettings, LocalStorageKeys, ReporteConsolidadoCajaAgrupadorConstants, SearchReporteConsolidadoCajaRequestDto } from '../../../../../../src/app/shared/model';
import { MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import { ExportMediaTypeConstants } from '../../../../shared/model';

@Component({
    selector: 'app-dialogDetalleMovimientosConsolidadoCaja',
    templateUrl: 'dialogDetalleMovimientosConsolidadoCaja.component.html'
})

export class DialogDetalleMovimientosConsolidadoCajaComponent implements OnInit {

  isSearching: boolean = false;
  isExporting: boolean = false;

  @ViewChild('grid')
  public grid: GridComponent;
  public query: Query;

  esMonedaConversion: boolean = false;

  searchForm: FormGroup;
  mouseClick: number;

  public data: DataManager;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  public contextMenuItems: ContextMenuItemModel[];

  private readonly gridColumns = [
    { field: 'FechaMovimiento', headerText: 'Fecha', width: 80, type: 'date', format: "dd/MM/yyyy" },
    { field: 'TipoMovimientoNombre', headerText: 'Tipo', width: 80 },
    { field: 'Detalle', headerText: 'Detalle', width: 100 },
    { field: 'CuentaImputadaCodigo', headerText: 'Cuenta', width: 90 },
    { field: 'Estado', headerText: 'Estado', width: 90 },
    { field: 'MedioPago', headerText: 'Medio de Pago', width: 90 },
    { field: 'Moneda', headerText: 'Moneda', width: 50 },
    { field: 'Monto', headerText: 'Monto', width: 70, format: "N2", textAlign: 'right' },
    { field: 'FechaVencimiento', headerText: 'Vencimiento', width: 80, type: 'date', format: "dd/MM/yyyy" }
  ];

  constructor(
    private dialogRef: MatDialogRef<DialogDetalleMovimientosConsolidadoCajaComponent>,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private movimientoService: MovimientoService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public input: DialogDetalleMovimientosConsolidadoCajaRequestDto) {

  }

  ngOnInit() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    this.buildForm();
    this.setQueryParams();

    var monedaConversionId = this.searchForm.get("MonedaConversionId")?.value;
    this.esMonedaConversion = (monedaConversionId != null && monedaConversionId > 0);

    setTimeout(() => {
      this.sharedFunctions.setColumnsVisibility("Estado", this.grid, this.gridColumns);
      this.sharedFunctions.setColumnsVisibility("MedioPago", this.grid, this.gridColumns);
      this.sharedFunctions.setColumnsVisibility("FechaVencimiento", this.grid, this.gridColumns);

      if (this.searchForm.get("VerPorCuentaImputada")?.value == null || this.searchForm.get("VerPorCuentaImputada")?.value == false)
        this.sharedFunctions.setColumnsVisibility("CuentaImputadaCodigo", this.grid, this.gridColumns);

      this.data = new DataManager({
        url: this.movimientoService.searchReporteConsolidadoCajaDetalleUrl(),
        adaptor: new WebApiAdaptor(),
        headers: [this.movimientoService.getAuthorizationHeader(),this.movimientoService.getTenantHeader()]
      });
    }, 500);

    this.contextMenuItems = this.sharedFunctions.initializeContextMenu(this.gridColumns);
  }

  buildForm() {
    var fechaHoy = new Date();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'CampoAgrupador': [ReporteConsolidadoCajaAgrupadorConstants.Tenant],
      'MonedaConversionId': [null],
      'ProveedorId': [null],
      'PersonaId': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      'CuentaImputadaId': [null],
      'MonedaId': [null],
      'FechaDesde': [new Date(fechaHoy.getFullYear(), fechaHoy.getMonth(), 1)],
      'FechaHasta': [fechaHoy],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [fechaHoy],
      'VerPorCuentaImputada': [null],
      'DescartarPendientes': [null],
      'VerBalancesNoCero': [null]
    });

    if (this.input != null && this.input.ReportFilter != null)
      this.searchForm.patchValue(this.input.ReportFilter);
  }

  onSearch() {
    this.setQueryParams();
    this.grid?.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "UnidadFuncionalId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.UnidadFuncionalId;
    else
      this.query.addParams("UnidadFuncionalId",this.searchForm.value.UnidadFuncionalId);

    index = this.query.params.findIndex(obj => obj.key === "ProveedorId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ProveedorId;
    else
      this.query.addParams("ProveedorId",this.searchForm.value.ProveedorId);

    index = this.query.params.findIndex(obj => obj.key === "PersonaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PersonaId;
    else
      this.query.addParams("PersonaId",this.searchForm.value.PersonaId);

    index = this.query.params.findIndex(obj => obj.key === "CuentaImputadaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.CuentaImputadaId;
    else
      this.query.addParams("CuentaImputadaId",this.searchForm.value.CuentaImputadaId);

    index = this.query.params.findIndex(obj => obj.key === "MonedaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaId;
    else
      this.query.addParams("MonedaId",this.searchForm.value.MonedaId);

    index = this.query.params.findIndex(obj => obj.key === "FechaDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaDesde", this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaHasta", this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoDesde", this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoHasta", this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "VerPorCuentaImputada");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerPorCuentaImputada;
    else
      this.query.addParams("VerPorCuentaImputada", this.searchForm.value.VerPorCuentaImputada);

    index = this.query.params.findIndex(obj => obj.key === "DescartarPendientes");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.DescartarPendientes;
    else
      this.query.addParams("DescartarPendientes", this.searchForm.value.DescartarPendientes);

    index = this.query.params.findIndex(obj => obj.key === "VerBalancesNoCero");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerBalancesNoCero;
    else
      this.query.addParams("VerBalancesNoCero", this.searchForm.value.VerBalancesNoCero);

    index = this.query.params.findIndex(obj => obj.key === "CampoAgrupador");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.CampoAgrupador;
    else
      this.query.addParams("CampoAgrupador", this.searchForm.value.CampoAgrupador);

    index = this.query.params.findIndex(obj => obj.key === "MonedaConversionId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaConversionId;
    else
      this.query.addParams("MonedaConversionId",this.searchForm.value.MonedaConversionId);
  }

  onAccept() {
    this.dialogRef.close();
  }

  onExport() {
    var search = new SearchReporteConsolidadoCajaRequestDto(null, null, null, "", null, null, null, null, null, this.searchForm.value.Proveedor?.Id, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.movimientoService.exportReporteConsolidadoCajaDetalle(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "ReporteConsolidadoCajaDetalle_" + this.datePipe.transform(new Date(), "yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  //Detecta que botón del mouse se presionó sobre una row
  //event.button = 0 --> Click.Derecho
  //event.button = 2 --> Click.Izquierdo
  onClickRow(event:MouseEvent){
    this.mouseClick = event.button;
  }

  //Si se presionó el botón Derecho del mouse, la row no cambia de estado en su checkbox
  //Soluciona selección de checkbox cuando se quiere abrir menuContext
  rowSelecting(args) {
    if (this.mouseClick == 2) {
      args.cancel = true;     //cancel the selection during opening context menu by right click
    }
  }

  contextMenuOpen(args: any): void {
    args.event.stopPropagation();
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items, args.event.target, this.grid, this.gridColumns);
  }

  contextMenuClick(args: MenuEventArgs): void {
    args.event?.stopPropagation();
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.grid, this.gridColumns);
  }
}
